import {
  WebsiteLayout,
  useUpdateHeader,
  HEADER_THEMES,
  useCleanHeader,
  TalentNewsletterSections,
  WebsiteSeo,
} from '@platform/website-components'
import { ReactElement, useRef } from 'react'
import { Widget } from '@typeform/embed-react'

import styles from './index.module.scss'

const SEO = {
  title: 'Companies // Olby',
  description: 'Engaging tech talent for trustworthy companies',
}

const Companies = () => {
  const sectionRef = useRef<HTMLDivElement | null>(null)
  const newsletterRef = useRef<HTMLElement | null>(null)

  useUpdateHeader(sectionRef, HEADER_THEMES.NEUTRAL_BACKGROUND)
  useUpdateHeader(newsletterRef, HEADER_THEMES.EXT_DEEP_BLUE)
  useCleanHeader()

  return (
    <>
      <div className={styles['wrapper']} ref={sectionRef}>
        <WebsiteSeo seo={SEO} />
        <div className={styles['content-wrapper']}>
          <h1 className={styles['title']}>Become a partner company</h1>
          <p className={styles['description']}>
            Fill in your company information for us to contact you and engage best possible talent
            to work at your company.
          </p>
          <div className={styles['content']}>
            <Widget id="n5Ghm0QH" className={styles.typeform} />
          </div>
        </div>
      </div>
      <TalentNewsletterSections ref={newsletterRef} />
    </>
  )
}

export default Companies

Companies.getLayout = (page: ReactElement) => {
  return (
    <WebsiteLayout shouldChangeBgColor headerInitialTheme={HEADER_THEMES.NEUTRAL_BACKGROUND}>
      {page}
    </WebsiteLayout>
  )
}
